import React from "react";
import { TraceInformation } from "./tracing";

export const LayoutMessage = ({ children }: { children: React.ReactNode }) => (
  <div className="flex justify-center items-center h-screen text-primary-foreground">
    <div className="text-center">
      {children}
      <p className="mb-4">
        Please contact your association administrator to get access to
        this application.
      </p>
      <TraceInformation />
    </div>
  </div>
);
